// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"ede3b6d8","160":"c6278b0a","208":"9d9254ce","293":"c4a30103","453":"635f5f07","516":"f7f04a55","519":"aca098b9","917":"39a3c9dc","946":"36b6be0a"}[chunkId] + ".chunk.js";
};